module.exports = __webpack_public_path__ + "img/02.5fdd75ef.jpg";